import React from "react";
import Dropdown from "../DropDown";

interface EnabledDropdownProps {
  selectedEnabled: string;
  onEnabledChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  onFocus?: () => void;
}

const EnabledDropdown: React.FC<EnabledDropdownProps> = ({
  selectedEnabled,
  onEnabledChange,
  disabled = false,
  className = "",
  onFocus,
}) => {
  const options = [
    { value: "Y", label: "Y" },
    { value: "N", label: "N" },
  ];

  return (
    <Dropdown
      options={options}
      selectedValue={selectedEnabled}
      onValueChange={onEnabledChange}
      disabled={disabled}
      className={className}
      placeholder="Select Enabled"
      onFocus={onFocus}
    />
  );
};

export default EnabledDropdown;
